module.exports = __webpack_public_path__ + "static/media/student-summary-recieve.baf64198.png";